import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ReportingPage } from './ReportingPage';
import { PortfoliosPage } from './PortfoliosPage';
import { GoalsPage } from './GoalsPage';
export function InsightsPage() {
    return (_jsxs(Routes, { children: [_jsx(Route, { path: "/", element: _jsx(Navigate, { to: "reporting", replace: true }) }), _jsx(Route, { path: "/reporting/*", element: _jsx(ReportingPage, {}) }), _jsx(Route, { path: "/portfolios/*", element: _jsx(PortfoliosPage, {}) }), _jsx(Route, { path: "/goals/*", element: _jsx(GoalsPage, {}) })] }));
}
